module.exports = __webpack_public_path__ + "img/gs2.a256a22c.png";